import { DocumentModel } from "models/DocumentModel";
import { useApi } from "providers";
import React from "react";

interface DisplayDocumentLinkProps {
  value?: DocumentModel;
}

export const DisplayDocumentLink: React.FC<DisplayDocumentLinkProps> = ({ value }) => {
  const { downloadApi } = useApi();

  if (!value) {
    return null;
  }

  const { canDownload, downloadUrl, fileName, iconClass } = value;
  const tooltip = [];
  tooltip.push(fileName);

  const isDownloadEnabled = canDownload && !!downloadUrl;

  return (
    <span className="global-tooltip-trigger" title={tooltip.join("")}>
      {!isDownloadEnabled && (
        <span className="file-icon-link">
          <i className={`file-icon ${iconClass}`} />
          {fileName}
        </span>
      )}

      {isDownloadEnabled && (
        <a
          onClick={async (e) => {
            e.preventDefault();
            await downloadApi.handleDownload(downloadUrl, fileName);
          }}
          className="file-icon-link"
        >
          <i className={`file-icon ${iconClass}`} />
          {fileName}
        </a>
      )}
    </span>
  );
};
